import React, { memo } from "react"
import PropTypes from "prop-types"
import Icon from "./Icon"
import { useIsWideImage } from "hooks/useIsWideImage"

CircleImage.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string.isRequired,
  size: PropTypes.number,
  border: PropTypes.bool,
  isContain: PropTypes.bool,
  className: PropTypes.string,
  placeholderIconName: PropTypes.string
}

function CircleImage({ src, alt, size = 35, border = true, isContain = false, className, placeholderIconName, ...rest }) {
  // isContain: a clearly wide image (e.g. a business logo) is shown whole at its natural ratio instead of being cropped to a
  // circle. Square and ordinary images keep the default circle look.
  const isWide = useIsWideImage(isContain ? src : null)
  const isContainedImage = isContain && !!src && isWide
  const classes = [isContainedImage ? "object-fit-contain" : "rounded-circle object-fit-cover aspect-ratio-1"]
  className && classes.push(className)
  border && classes.push("border")
  !src && classes.push("p-0 border-light bg-gray-lightest text-gray-light")

  return src ? (
    <img src={src} alt={alt} className={classes.join(" ")} width={isContainedImage ? undefined : size} height={size} {...rest} />
  ) : (
    <Icon iconName={placeholderIconName} className={classes.join(" ")} width={size} height={size} {...rest} />
  )
}

export default memo(CircleImage)
